import type { ExerciceFiscal } from '@shared/types/ExerciceFiscal';

/**
 * E_NEW1 — garde clôture d’exercice : impossible sans exercice au statut « ouvert ».
 */
export class AucunExerciceOuvertError extends Error {
  constructor(message = 'Impossible de clôturer : aucun exercice ouvert.') {
    super(message);
    this.name = 'AucunExerciceOuvertError';
  }
}

export function isExerciceOuvert(
  exercice: ExerciceFiscal | null | undefined,
): exercice is ExerciceFiscal {
  return Boolean(exercice && exercice.statut === 'ouvert');
}

/** Refuse la clôture si l’exercice fourni n’est pas ouvert (ou absent). */
export function assertExerciceOuvert(
  exercice: ExerciceFiscal | null | undefined,
): asserts exercice is ExerciceFiscal {
  if (!isExerciceOuvert(exercice)) {
    throw new AucunExerciceOuvertError();
  }
}

/** Sélectionne le premier exercice ouvert d’une liste ; refuse si aucun. */
export function requireExerciceOuvert(
  exercices: readonly ExerciceFiscal[],
): ExerciceFiscal {
  const ouvert = exercices.find((e) => e.statut === 'ouvert');
  if (!ouvert) {
    throw new AucunExerciceOuvertError();
  }
  return ouvert;
}
